const channel = new BroadcastChannel('channel');

export default channel;
